export interface IProductApiStatusState
{
    //Errors
    productsError: string | null;
    productError: string | null;
    versionsError: string | null;
    notesError: string | null;
    createVersionError: string | null;
    createProductError: string | null;
    createEmailError: string | null;
    createSubscriptionError: string | null;
    createUnsubscribeError: string | null;
    createNoteError: string | null;
    editError: string | null;

    initialVersionLoad: boolean | null;

    //Post Status
    changedProduct: boolean | null;
    importedTranslation: boolean | null;
    productDeleted: boolean | null;
    versionDeleted: boolean | null;
    noteDeleted: boolean | null;
    checkVersion: CheckStatusEnum | null;
    checkNote: CheckStatusEnum | null;
    sendMail: boolean | null;
    addedProduct: boolean | null;
    addedVersion: boolean | null;
    addedNote: boolean | null;
    downloadedVersion: boolean | null;
    addedSubscription: boolean | null;
    removedSubscription: boolean | null;
    unsubscribed: boolean | null;
    editedValue: boolean | null;
    exportedTranslation: boolean | null;
}

export const defaultProductApiStatusState: IProductApiStatusState = {
    productsError: null,
    productError: null,
    versionsError: null,
    notesError: null,
    createVersionError: null,
    createProductError: null,
    createNoteError: null,
    createEmailError: null,
    createSubscriptionError: null,
    createUnsubscribeError: null,
    editError: null,

    initialVersionLoad: null,

    changedProduct: null,
    importedTranslation: null,
    productDeleted: null,
    versionDeleted: null,
    noteDeleted: null,
    checkVersion: null,
    checkNote: null,
    addedVersion: null,
    addedProduct: null,
    addedNote: null,
    downloadedVersion: null,
    sendMail: null,
    addedSubscription: null,
    removedSubscription: null,
    unsubscribed: null,
    editedValue: null,
    exportedTranslation: null,
}

export enum CheckStatusEnum
{
    Available,
    AlreadyExits,
    Invalid,
}

